unit UHistoryList;

interface

uses
  System.Contnrs, UHistoryModel, UEssentialHelper, UMainConfig, Js, UStampList,
  WebLib.ExtCtrls, UStampModel, UPictureModel;

type
  THistoryList = class(TObjectList)
  private
    FLocked: Boolean;
    FTimer: TTimer;
    FOnListChanged: TListChangedEvent;
    FMainConfig: TMainConfig;
    function AllItemsTransmitted: Boolean;
    function GetItem(i: Integer): THistoryModel;
    function GetNotTransmittedItem: THistoryModel;
    procedure DoListChanged;
    procedure DoTimer(Sender: TObject);
    procedure PropertyChanged(Sender: TObject; PropertyName: string);
    procedure Reorganize;
    procedure Sort;
    procedure SetValues(Json: string); overload;
    procedure SetValues(obj: TJsObject); overload;
    procedure TransmitPicture(Item: THistoryModel);
    procedure TransmitStamp(Item: THistoryModel);
    procedure SetOnListChanged(const Value: TListChangedEvent);
  public
    constructor Create(MainConfig: TMainConfig);
    function GetLastFakStamp: TStampModel;
    function GetLastStamp: TStampModel;
    function ToJson: string;
    procedure Add(Item: THistoryModel);
    procedure Delete(Index: Integer);
    procedure Insert(Index: Integer; Item: THistoryModel);
    procedure Merge(StampList: TStampList);
    property Items[i: Integer]: THistoryModel read GetItem;
    property OnListChanged: TListChangedEvent read FOnListChanged
      write SetOnListChanged;
    property MainConfig: TMainConfig read FMainConfig;
  end;

implementation

uses WebLib.Json, System.SysUtils, WebLib.Storage;

{ THistoryList }

procedure THistoryList.Add(Item: THistoryModel);
begin
  Item.OnPropertyChanged := Self.PropertyChanged;
  inherited Add(Item);
  Self.Sort;
  Self.DoListChanged;
end;

function THistoryList.AllItemsTransmitted: Boolean;
var
  i: Integer;
begin
  Result := true;
  i := 0;
  while Result and (i < Self.Count) do
  begin
    Result := Result and Self.Items[i].Transmitted;
    Inc(i);
  end;
end;

constructor THistoryList.Create(MainConfig: TMainConfig);
var
  s: string;
begin
  inherited Create;
  Self.FMainConfig := MainConfig;
  Self.OnListChanged := nil;
  FLocked := False;
  FTimer := TTimer.Create(nil);
  FTimer.Enabled := False;
  FTimer.Interval := 15000;
  FTimer.OnTimer := Self.DoTimer;
  s := TLocalStorage.GetValue('HistoryList' + Self.MainConfig.User.PersonalNr);
  if s <> '' then
    Self.SetValues(s);
end;

procedure THistoryList.Delete(Index: Integer);
begin
  inherited Delete(Index);
  Self.DoListChanged;
end;

procedure THistoryList.DoListChanged;
begin
  Self.Reorganize;
  TLocalStorage.SetValue('HistoryList' + Self.MainConfig.User.PersonalNr,
    Self.ToJson);
  FTimer.Enabled := not Self.AllItemsTransmitted;
  if Assigned(Self.OnListChanged) then
    Self.OnListChanged(Self);
end;

procedure THistoryList.DoTimer(Sender: TObject);
var
  Item: THistoryModel;
begin
  if not FLocked then
  begin
    Item := Self.GetNotTransmittedItem;
    if Item = nil then
      FTimer.Enabled := False
    else
    begin
      case Item.Kind of
        mkUnknown:
          begin
            Item.TransmittedAt := now;
            FLocked := False;
          end;
        mkStamp:
          Self.TransmitStamp(Item);
        mkPicture:
          Self.TransmitPicture(Item);
      end;
    end;
  end;
end;

function THistoryList.GetItem(i: Integer): THistoryModel;
begin
  Result := inherited GetItem(i) as THistoryModel;
end;

function THistoryList.GetLastFakStamp: TStampModel;
var
  Item: THistoryModel;
begin
  Result := nil;
  if Self.Count > 0 then
  begin
    Item := Self.Items[0];
    if (Item.Kind = mkStamp) and (Item.Stamp.Art = 'AA') then
      Result := Item.Stamp;
  end;
end;

function THistoryList.GetLastStamp: TStampModel;
var
  i: Integer;
  found: Boolean;
  Item: THistoryModel;
  Stamp: TStampModel;
begin
  i := 0;
  found := False;
  while not found and (i < Self.Count) do
  begin
    Item := Self.Items[i];
    if Item.Kind = mkStamp then
    begin
      Stamp := Item.Stamp;
      if (Stamp.Art = 'KO') or (Stamp.Art = 'GE') then
        found := true;
    end;
    if not found then
      Inc(i);
  end;
  if found then
    Result := Stamp
  else
    Result := nil;
end;

function THistoryList.GetNotTransmittedItem: THistoryModel;
var
  i: Integer;
  found: Boolean;
begin
  found := False;
  i := Self.Count - 1;
  while not found and (i >= 0) do
    if not Self.Items[i].Transmitted then
      found := true
    else
      Dec(i);
  if found then
    Result := Self.Items[i]
  else
    Result := nil;
end;

procedure THistoryList.Insert(Index: Integer; Item: THistoryModel);
begin
  Item.OnPropertyChanged := Self.PropertyChanged;
  inherited Insert(Index, Item);
  Self.Sort;
  Self.DoListChanged;
end;

procedure THistoryList.Merge(StampList: TStampList);
var
  i, j: Integer;
  found: Boolean;
  Item: THistoryModel;
  Stamp: TStampModel;
  dummy: TListChangedEvent;
begin
  dummy := Self.OnListChanged;
  Self.OnListChanged := nil;
  for j := 0 to StampList.Count - 1 do
  begin
    Stamp := StampList.Items[j];
    i := 0;
    found := False;
    while not found and (i < Self.Count) do
    begin
      Item := Self.Items[i];
      if (Item.Kind = mkStamp) and Stamp.Equals(Item.Stamp) then
        found := true
      else
        Inc(i);
    end;
    if not found then
    begin
      Item := THistoryModel.Create(Stamp, Stamp.Zeitpunkt);
      Self.Add(Item);
    end;
  end;
  Self.Sort;
  Self.Reorganize;
  Self.OnListChanged := dummy;
  Self.DoListChanged;
end;

procedure THistoryList.PropertyChanged(Sender: TObject; PropertyName: string);
begin
  if (PropertyName = 'TransmittedAt') and (PropertyName = 'HasPdfs') then
    Self.DoListChanged;
end;

procedure THistoryList.Reorganize;
var
  i: Integer;
begin
  i := Self.Count - 1;
  while (i >= 0) and
    (Self.Count > Self.MainConfig.OverviewConfig.StampsCount) do
    if Self.Items[i].Transmitted then
    begin
      inherited Delete(i);
      i := Self.Count - 1;
    end
    else
      Dec(i);
end;

procedure THistoryList.SetOnListChanged(const Value: TListChangedEvent);
begin
  FOnListChanged := Value;
end;

procedure THistoryList.SetValues(obj: TJsObject);
var
  Count: Integer;
  i: Integer;
begin
  Self.Clear;
  if obj['Count'] <> nil then
  begin
    Count := StrToInt(string(obj['Count']));
    for i := 0 to Count - 1 do
      if obj['Item' + IntToStr(i)] <> nil then
        Self.Add(THistoryModel.Create(string(obj['Item' + IntToStr(i)])));
  end;
end;

procedure THistoryList.Sort;
var
  i, j: Integer;
  Item1, Item2: THistoryModel;
begin
  if Self.Count > 1 then
  begin
    for i := 0 to Self.Count - 1 do
      for j := 0 to Self.Count - 2 do
      begin
        Item1 := Self.Items[j];
        Item2 := Self.Items[j + 1];
        if Item1.CreatedAt = Item2.CreatedAt then
        begin
          if (Item1.Kind = mkStamp) and (Item2.Kind = mkStamp) then
          begin
            if Less(Item1.Stamp.Art, Item2.Stamp.Art) then
              Self.Exchange(j, j + 1);
          end;
        end
        else if Item1.CreatedAt < Item2.CreatedAt then
          Self.Exchange(j, j + 1)
      end;
  end;
end;

procedure THistoryList.SetValues(Json: string);
var
  obj: TJsObject;
begin
  obj := TJsJson.parseObject(Json);
  Self.SetValues(obj);
end;

function THistoryList.ToJson: string;
var
  obj: TJsonObject;
  i: Integer;
begin
  obj := TJsonObject.Create;
  obj.AddPair('Count', IntToStr(Self.Count));
  for i := 0 to Self.Count - 1 do
    obj.AddPair('Item' + IntToStr(i), Self.Items[i].ToJson);
  Result := obj.ToJson;
  obj.Free;
end;

procedure THistoryList.TransmitPicture(Item: THistoryModel);
  procedure CallBack(Sender: TObject);
  begin
    if (Sender is TPictureModel) and (Sender as TPictureModel).Result.ResultValue
    then
      Item.TransmittedAt := now;
    FLocked := False;
  end;

  procedure HandlingError(Sender: TObject; AMsg: string);
  begin
    FLocked := False;
  end;

begin
  Item.Picture.OnConfirmation := CallBack;
  Item.Picture.OnError := HandlingError;
  Item.Picture.Insert(Self.MainConfig.Uri);
end;

procedure THistoryList.TransmitStamp(Item: THistoryModel);
  procedure CallBack(Sender: TObject);
  begin
    if (Sender is TStampModel) and (Sender as TStampModel).Result.ResultValue
    then
      Item.TransmittedAt := now;
    FLocked := False;
  end;

  procedure HandlingError(Sender: TObject; AMsg: string);
  begin
    FLocked := False;
  end;

begin
  Item.Stamp.OnPropertyChanged := CallBack;
  Item.Stamp.OnError := HandlingError;
  Item.Stamp.Insert(Self.MainConfig.Uri);
end;

end.
